module.exports = window.initializeRemote('model_factory');